import { gql, TypedDocumentNode } from '@apollo/client'

import { Ability } from 'providers/casl'
import { permitFields } from 'providers/graphql/utils'
import { DomainUnfilledRecoveryDTO } from '../types/domainUnfilledRecoveryDTO'

export const DOMAIN_UNFILLED_RECOVERY_FRAGMENT = (
  ability: Ability,
): TypedDocumentNode<DomainUnfilledRecoveryDTO> => gql`
  fragment DomainUnfilledRecoveryFragment on DomainUnfilledRecovery {
    ${permitFields<DomainUnfilledRecoveryDTO>({
      baseAdUnitPath: ability.can('read', 'DomainField-baseAdUnitPath'),
    })}

    cacheAndReusePrebidBids
  }
`
